export default function Hdg({ translate, lang }) {
	return (
		<div className="match-play-container">
			<div>
				<div class="subhead">
					Los Cabos Junior Golf Series es una serie de tres torneos de nueve
					hoyos, creada para que los jóvenes golfistas de Los Cabos tengan un
					espacio para jugar, convivir y competir. Poniendo a prueba sus
					habilidades en el campo, pero sobre todo divirtiéndose y aprendiendo.
					El formato es Stroke Play individual y será por categorías de edad.
					Divisiones varonil y femenil. Años de nacimiento 2007 - 2020.
					<br />
					<br />
					Como cierre de la serie, todos los interesados tendrán la oportunidad
					de jugar en el campo sede del WWT Championship, El Cardonal en
					Diamante Cabo San Lucas. En esta última etapa, los jugadores de 11 en
					años en adelante jugarán 18 hoyos, mientras que los participantes de
					10 años o menores jugarán 9 hoyos.
				</div>

				<div className="spacer-15"> </div>
			</div>
		</div>
	);
}
